// extracted by mini-css-extract-plugin
module.exports = {"ModeToggleWrapper":"WorkspaceModes_ModeToggleWrapper__Tr1x8","hidden":"WorkspaceModes_hidden__2O88i","modeName":"WorkspaceModes_modeName__3FjIW"};